module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iNCIgdmlld0JveD0iMCAwIDE2IDQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IG9wYWNpdHk9IjAuMiIgd2lkdGg9IjE2IiBoZWlnaHQ9IjQiIGZpbGw9IiM2Qjc1N0YiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/NewPackSelector/not-included-icon.svg
// module id = 471
// module chunks = 0